// extracted by mini-css-extract-plugin
module.exports = {"hexagon":"Hexagon-module--hexagon--iubGt","inner":"Hexagon-module--inner--3UDWw","content":"Hexagon-module--content--3bVlA","title":"Hexagon-module--title--2bPKk"};